import { action, computed, makeObservable, observable } from 'mobx';

import type { AxiosInstance } from 'axios';
import type { DirectoryTableMediator } from 'src/components/directory-table/directory-table-mediator';
import type { IDirectoryPageCurrentDirectory } from 'src/pages/directory/directory-page-service';
import type { NotificationsService } from 'src/services/notifications-service';

import { PluginName, type IPlugin } from '../../types';

import { RefreshLogsApi } from './refresh-logs.api';

export class RefreshLogs implements IPlugin {
  private readonly api: RefreshLogsApi;
  readonly name = PluginName.RefreshLogs;
  @observable tableMediator: DirectoryTableMediator | null = null;

  @observable isLoading: boolean = false;

  readonly directoryPageService: IDirectoryPageCurrentDirectory;

  private readonly notificationsService: NotificationsService;

  constructor(
    gatewayAgent: AxiosInstance,
    notificationsService: NotificationsService,
    directoryPageService: IDirectoryPageCurrentDirectory,
  ) {
    makeObservable(this);
    this.api = new RefreshLogsApi(gatewayAgent);
    this.notificationsService = notificationsService;
    this.directoryPageService = directoryPageService;
  }

  @computed
  get generalDataWellId(): number | null {
    const generalDataValues = this.tableMediator?.generalDataValues;
    if (generalDataValues?.ecosystemWellId && typeof generalDataValues.ecosystemWellId === 'number') {
      return generalDataValues.ecosystemWellId;
    }

    return null;
  }

  @action.bound
  setTableMediator(tableMediator: DirectoryTableMediator): void {
    this.tableMediator = tableMediator;
  }

  refreshLogs = async () => {
    if (!this.generalDataWellId) {
      console.error('no wellId');
      return;
    }

    const wellIds = [this.generalDataWellId];
    this.isLoading = true;
    try {
      await this.api.enrichByWellIds(wellIds);
      this.notificationsService.showSuccessMessageT('plugins:RefreshLogs.successRefreshing');
    } catch (error) {
      console.error('error', error);
      this.notificationsService.showErrorMessageT('plugins:RefreshLogs.errorRefreshing');
    } finally {
      this.isLoading = false;
    }
  };
}
